"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartZoomSlider = ChartZoomSlider;
var React = _interopRequireWildcard(require("react"));
var _hooks = require("@mui/x-charts/hooks");
var _ChartAxisZoomSlider = require("./internals/ChartAxisZoomSlider");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders the zoom slider for all x and y axes that have it enabled.
 */
function ChartZoomSlider() {
  const {
    xAxisIds,
    xAxis: xAxes
  } = (0, _hooks.useXAxes)();
  const {
    yAxisIds,
    yAxis: yAxes
  } = (0, _hooks.useYAxes)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [xAxisIds.map(axisId => {
      const xAxis = xAxes[axisId];
      const slider = xAxis.zoom?.slider;
      if (!slider?.enabled) {
        return null;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartAxisZoomSlider.ChartAxisZoomSlider, {
        axisId: axisId,
        axisDirection: "x"
      }, axisId);
    }), yAxisIds.map(axisId => {
      const yAxis = yAxes[axisId];
      const slider = yAxis.zoom?.slider;
      if (!slider?.enabled) {
        return null;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartAxisZoomSlider.ChartAxisZoomSlider, {
        axisId: axisId,
        axisDirection: "y"
      }, axisId);
    })]
  });
}